/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      email
      role
      plan
      profile {
        id
        userProfileId
        companyName
        logo
        description
        services
        location
        contactWhatsApp
        isVerified
        createdAt
        updatedAt
        owner
        __typename
      }
      leads {
        nextToken
        __typename
      }
      vehicles {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileId
      owner
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        email
        role
        plan
        createdAt
        updatedAt
        userProfileId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProfile = /* GraphQL */ `
  query GetProfile($id: ID!) {
    getProfile(id: $id) {
      id
      userProfileId
      companyName
      logo
      description
      services
      location
      contactWhatsApp
      isVerified
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listProfiles = /* GraphQL */ `
  query ListProfiles(
    $filter: ModelProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userProfileId
        companyName
        logo
        description
        services
        location
        contactWhatsApp
        isVerified
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLead = /* GraphQL */ `
  query GetLead($id: ID!) {
    getLead(id: $id) {
      id
      leadOwnerId
      type
      sourceURL
      customerName
      customerPhone
      message
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listLeads = /* GraphQL */ `
  query ListLeads(
    $filter: ModelLeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeads(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        leadOwnerId
        type
        sourceURL
        customerName
        customerPhone
        message
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const profilesByUserProfileIdAndId = /* GraphQL */ `
  query ProfilesByUserProfileIdAndId(
    $userProfileId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    profilesByUserProfileIdAndId(
      userProfileId: $userProfileId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userProfileId
        companyName
        logo
        description
        services
        location
        contactWhatsApp
        isVerified
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const leadsByLeadOwnerId = /* GraphQL */ `
  query LeadsByLeadOwnerId(
    $leadOwnerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    leadsByLeadOwnerId(
      leadOwnerId: $leadOwnerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadOwnerId
        type
        sourceURL
        customerName
        customerPhone
        message
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVehicle = /* GraphQL */ `
  query GetVehicle($id: ID!) {
    getVehicle(id: $id) {
      id
      vehicleOwnerId
      year
      make
      model
      titleStatus
      mileage
      price
      isFeatured
      isCashDeal
      status
      description
      imageKey
      videoURL
      allImageKeys
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVehicles = /* GraphQL */ `
  query ListVehicles(
    $filter: ModelVehicleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        vehicleOwnerId
        year
        make
        model
        titleStatus
        mileage
        price
        isFeatured
        isCashDeal
        status
        description
        imageKey
        videoURL
        allImageKeys
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const vehiclesByVehicleOwnerId = /* GraphQL */ `
  query VehiclesByVehicleOwnerId(
    $vehicleOwnerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVehicleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vehiclesByVehicleOwnerId(
      vehicleOwnerId: $vehicleOwnerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        vehicleOwnerId
        year
        make
        model
        titleStatus
        mileage
        price
        isFeatured
        isCashDeal
        status
        description
        imageKey
        videoURL
        allImageKeys
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchVehicles = /* GraphQL */ `
  query SearchVehicles(
    $filter: SearchableVehicleFilterInput
    $sort: [SearchableVehicleSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableVehicleAggregationInput]
  ) {
    searchVehicles(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        vehicleOwnerId
        year
        make
        model
        titleStatus
        mileage
        price
        isFeatured
        isCashDeal
        status
        description
        imageKey
        videoURL
        allImageKeys
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
